import { useState } from 'react';
import { socket } from '../socket';
import { useI18n } from '../i18n/useI18n';
import type { QueueMessage } from '../types';
import { trackEvent } from '../analytics/posthog';
import ReactionIcon from './ReactionIcon';

interface Props {
  roomId: string | undefined;
  queue: QueueMessage[];
}

export default function ReactionPill({ roomId, queue }: Props) {
  const [poppedReaction, setPoppedReaction] = useState<string | null>(null);
  const { t } = useI18n();

  if (queue.length === 0) return null;

  return (
    <div className="reaction-pill">
      {[
        { type: 'heart' },
        { type: 'star' },
        { type: 'like' },
      ].map((r) => (
        <button
          key={r.type}
          className={`reaction-pill__btn ${poppedReaction === r.type ? 'reaction-pill__btn--popped' : ''}`}
          onClick={() => {
            const top = queue[0];
            if (top && roomId) {
              socket.emit('reaction', { roomId, messageId: top.id, type: r.type as any });
              trackEvent('reaction_sent', { roomId, type: r.type });
            }
            setPoppedReaction(r.type);
            setTimeout(() => setPoppedReaction(null), 150);
          }}
          aria-label={t('reaction.send', { type: r.type })}
        >
          <ReactionIcon type={r.type as any} />
        </button>
      ))}
    </div>
  );
}
